import { isEmptyObject } from '@/common/converter/utils/is-empty-object'

export const normalizePromotionProductInfo = (rawData) => {
  if (isEmptyObject(rawData)) return

  return {
    productCode: rawData?.product_code,
    salesAmount: rawData?.sales_amount,
    title: rawData?.title,
    titleDescription: rawData?.title_description,
    purchaseAmount: rawData?.purchase_amount,
    currencyTypeId: rawData?.currency_type_id,
    packageTypeId: rawData?.package_type_id,
    screenTypeId: rawData?.screen_type_id,
    screenQualityTypeId: rawData?.screen_quality_type_id,
    partnerId: rawData?.partner_id,
    packageMasterId: rawData?.package_master_id,
    marketTypeId: rawData?.market_type_id,
  }
}
